// src/pages/webSite/categories/CategoryProducts.js
// صفحة عرض منتجات التصنيف - تعرض جميع منتجات تصنيف معين مع عنوان التصنيف

// استيراد المكتبات والأدوات المطلوبة
import { useEffect, useState } from "react"; // هووكس React
import { Container } from "react-bootstrap"; // حاوية Bootstrap
import { useParams } from "react-router-dom"; // للحصول على معرف التصنيف من الرابط
import { CATEGORIES, PRO } from "../../../API/Api"; // روابط API
import { Axios } from "../../../API/Axios"; // عميل Axios المُعد
import { useLanguage } from "../../../Context/LanguageContext"; // هوك اللغة
import ProductCard from "../../../components/website/Products/ProductCard/ProductCard"; // بطاقة المنتج
import SectionHeader from "../../../components/website/Products/ProductCard/SectionHeader"; // عنوان القسم
import Skeltonshow from "../../../components/website/sekelton/skelton"; // مكون骨架 (تحميل)
import "../../../Css/Storefront.css"; // أنماط المتجر

// ================ المكون الرئيسي ================
export default function CategoryProducts ()
{
    // هوك اللغة للحصول على النصوص المترجمة
    const { t } = useLanguage();
    // الحصول على معرف التصنيف من الرابط
    const { id } = useParams();

    // حالات الصفحة
    const [ category, setCategory ] = useState( null ); // بيانات التصنيف
    const [ products, setProducts ] = useState( [] ); // قائمة المنتجات
    const [ loading, setLoading ] = useState( true ); // حالة التحميل

    // ===== جلب بيانات التصنيف والمنتجات =====
    useEffect( () =>
    {
        setLoading( true );

        // جلب التصنيفات والمنتجات بشكل متوازي
        Promise.all( [
            Axios.get( CATEGORIES ), // جلب جميع التصنيفات
            Axios.get( `/${ PRO }` ), // جلب جميع المنتجات
        ] )
            .then( ( [ categoriesRes, productsRes ] ) =>
            {
                // 1. العثور على التصنيف المطابق للمعرف
                const matchedCategory = categoriesRes.data.find(
                    ( item ) => String( item.id ) === String( id )
                );
                setCategory( matchedCategory || null );

                // 2. تصفية المنتجات حسب التصنيف وحالة النشر
                const filtered = productsRes.data.filter(
                    ( product ) =>
                        product.status === 'published' && // فقط المنتجات المنشورة
                        String( product.category ) === String( id ) // تطابق معرف التصنيف
                );
                setProducts( filtered );
            } )
            .catch( ( error ) => console.log( "Error fetching category products:", error ) )
            .finally( () => setLoading( false ) );
    }, [ id ] ); // إعادة التشغيل عند تغيير معرف التصنيف

    // ================ عرض الواجهة ================
    return (
        <div className="wc-page py-5">
            <Container>
                {/* عنوان الصفحة */ }
                <SectionHeader
                    title={ category ? category.title : "..." } // عنوان التصنيف أو مؤقت تحميل
                    subtitle={ t( 'categoriesPage.subtitle' ) } // النص الفرعي
                />

                { loading ? (
                    // عرض骨架 أثناء التحميل
                    <div className="product-grid">
                        <Skeltonshow height="300px" length="8" />
                    </div>
                ) : products.length === 0 ? (
                    // رسالة عند عدم وجود منتجات
                    <p className="text-center text-muted py-5">{ t( 'categoriesPage.noProducts' ) }</p>
                ) : (
                    // شبكة المنتجات
                    <div className="product-grid">
                        { products.map( ( product ) => (
                            <ProductCard
                                key={ product.id } // مفتاح فريد
                                id={ product.id } // معرف المنتج
                                title={ product.title } // عنوان المنتج
                                description={ product.description } // وصف المنتج
                                img={ product.images && product.images[ 0 ] ? product.images[ 0 ].image : "" } // الصورة الأولى
                                price={ product.price } // السعر الأصلي
                                discount={ product.discount } // السعر بعد الخصم
                                rating={ product.rating } // التقييم
                                sale={ product.sale } // حالة العرض الخاص
                            />
                        ) ) }
                    </div>
                ) }
            </Container>
        </div>
    );
}